import {Component, Input, OnInit} from '@angular/core';
import {MyProfileService} from '../service/my-profile.service';
import {getAlertMessage} from '../../shared/api-loaders';
import {SecurityQuestion} from '../model/security-question';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {MessageType} from '../../shared/messageType';
import {MessageService} from '../../shared/message.service';
import {ClaimsService} from '../../shared/claims.service';

@Component({
    selector: 're-security-questions',
    templateUrl: './security-questions.component.html',
    styleUrls: ['./security-questions.component.scss'],
    standalone: false
})
export class SecurityQuestionsComponent implements OnInit {

  securityQForm: UntypedFormGroup;
  securityQuestions: SecurityQuestion[] = [];
  userSelectedSQ: SecurityQuestion[] = [];
  ssoUserKey: string;
  edit: boolean;

  constructor(private fb: UntypedFormBuilder,
              private myProfileService: MyProfileService,
              private messageService: MessageService,
              private claimsService: ClaimsService) {
  }

  async ngOnInit() {
    this.securityQForm = this.fb.group({
      firstSQ: this.fb.group({
        securityQuestionId: [null, Validators.required],
        answer: ['******', Validators.required],
      }),
      secondSQ: this.fb.group({
        securityQuestionId: [null, Validators.required],
        answer: ['******', Validators.required],
      }),
      thirdSQ: this.fb.group({
        securityQuestionId: [null, Validators.required],
        answer: ['******', Validators.required],
      }),
    });

    // Disable
    this.securityQForm.get('firstSQ').get('securityQuestionId').disable();
    this.securityQForm.get('secondSQ').get('securityQuestionId').disable();
    this.securityQForm.get('thirdSQ').get('securityQuestionId').disable();

    this.ssoUserKey = this.claimsService.getSsoId();
    this.getSecurityQuestions();
    // Get user for sso id
    this.getUserSecurityQuestions();
  }

  // TODO: replace with angular validator
  uniqueAnswer() {
    const firstAnswer = this.securityQForm.get('firstSQ').value.answer;
    const secondAnswer = this.securityQForm.get('secondSQ').value.answer;
    const thirdAnswer = this.securityQForm.get('thirdSQ').value.answer;
    if (firstAnswer !== secondAnswer && firstAnswer !== thirdAnswer && secondAnswer !== thirdAnswer) {
      return true;
    } else {
      return false;
    }
  }

  // get all the security questions
  getSecurityQuestions() {
    this.myProfileService.myProfile_SecurityQuestions(null).subscribe(res => {
      res.securityQuestions.forEach(s => this.securityQuestions.push(s));

      this.addDefaultOption(this.securityQuestions);
    }, error => {
      this.messageService.send(getAlertMessage(error));
    });
  }

  // get the save security questions for an user
  getUserSecurityQuestions() {
    this.myProfileService.myProfile_userSecurityQuestions().subscribe(res => {
      if (res != null && res.length > 0) {
        /*this.firstSelectedSQ = res[0].securityQuestionId;
        this.secondSelectedSQ = res[1].securityQuestionId;
        this.thirdSelectedSQ = res[2].securityQuestionId;*/
        this.securityQForm.patchValue({
          firstSQ: {
            securityQuestionId: res[0].securityQuestionId,
            answer: '******'
          },
          secondSQ: {
            securityQuestionId: res[1].securityQuestionId,
            answer: '******'
          },
          thirdSQ: {
            securityQuestionId: res[2].securityQuestionId,
            answer: '******'
          }
        })
      }
    }, error => {
      // need not to show the error message as this could reach here when the user is not set up security questions?
      // this.messageService.send(getAlertMessage(error));
      this.patchForm(null, '');
    });
  }

  patchForm(securityQuestionId: number, answer: string) {
    this.securityQForm.patchValue({
      firstSQ: {
        securityQuestionId: securityQuestionId,
        answer: answer
      },
      secondSQ: {
        securityQuestionId: securityQuestionId,
        answer: answer,
      },
      thirdSQ: {
        securityQuestionId: securityQuestionId,
        answer: answer,
      }
    });
  }

  clickEdit() {
    this.edit = !this.edit;
    this.patchForm(null, '');
    this.securityQForm.get('firstSQ').get('securityQuestionId').enable();
    this.securityQForm.get('secondSQ').get('securityQuestionId').enable();
    this.securityQForm.get('thirdSQ').get('securityQuestionId').enable();
  }

  cancel() {
    this.edit = !this.edit;
    this.getUserSecurityQuestions();
    this.securityQForm.get('firstSQ').get('securityQuestionId').disable();
    this.securityQForm.get('secondSQ').get('securityQuestionId').disable();
    this.securityQForm.get('thirdSQ').get('securityQuestionId').disable();
  }

  @Input()
  showCancel = false

  SQ_onSubmit() {
    this.userSelectedSQ.push(this.securityQForm.get('firstSQ').value);
    this.userSelectedSQ.push(this.securityQForm.get('secondSQ').value);
    this.userSelectedSQ.push(this.securityQForm.get('thirdSQ').value);
    this.myProfileService
      .myProfile_SaveUserSecurityQuestions(this.userSelectedSQ)
      .subscribe(
        res => {
          this.userSelectedSQ = [];
          this.cancel();
          this.messageService.send({type: MessageType.UserSQSaved, message: 'Security questions are saved successfully.'});
        },
        err => {
          this.messageService.send(getAlertMessage(err));
          this.userSelectedSQ = [];
        }
      );
  }

  get filteredFirstfaq() {
    if (this.edit) {
      return this.securityQuestions.filter((faq) => {
        const secondQID = this.securityQForm.get('secondSQ').value.securityQuestionId;
        const thirdQID = this.securityQForm.get('thirdSQ').value.securityQuestionId;

        return faq.securityQuestionId === null || (faq.securityQuestionId != secondQID && faq.securityQuestionId != thirdQID);
      })
    } else {
      return this.securityQuestions;
    }
  }


  get filteredSecfaq() {
    if (this.edit) {
      return this.securityQuestions.filter((faq) => {
        const firstQID = this.securityQForm.get('firstSQ').value.securityQuestionId;
        const thirdQID = this.securityQForm.get('thirdSQ').value.securityQuestionId;

        if (!firstQID)
          return faq.securityQuestionId == null;

        return faq.securityQuestionId === null || (faq.securityQuestionId != firstQID && faq.securityQuestionId != thirdQID);
     })
    } else {
      return this.securityQuestions;
    }
  }

  get filteredThirdfaq() {
    if (this.edit) {
      return this.securityQuestions.filter((faq) => {
        const firstQID = this.securityQForm.get('firstSQ').value.securityQuestionId;
        const secondQID = this.securityQForm.get('secondSQ').value.securityQuestionId;

        if (!secondQID)
          return faq.securityQuestionId == null;

        return faq.securityQuestionId === null || (faq.securityQuestionId != secondQID && faq.securityQuestionId != firstQID);
      })
    } else {
      return this.securityQuestions;
    }
  }

  getSecurityQuestionById(QID: number) {
    if (Array.isArray(this.securityQuestions) && this.securityQuestions.length) {
      return this.securityQuestions.find(x => x.securityQuestionId == QID).securityQuestion;
    }
  }

  addDefaultOption(options: any[]): any {
    options.unshift({securityQuestionId: null, securityQuestion: '- Not selected -'});
    return options;
  }
}
